import BookNowPermanentContractLabel from './BookNowPermanentContractLabel';

export default BookNowPermanentContractLabel;
